import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Stack } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayMinimalRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/shared/models/outputs/gateway-minimal-role.model';
import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface UserListRoleCellProps
  extends CellContext<GatewayUserModel, GatewayUserModel['roles']> {}

export const UserListRoleCell = (
  props: UserListRoleCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack>
      {getValue()?.map((r: GatewayMinimalRoleModel) => (
        <Link
          onClick={() =>
            navigate(
              generatePath(APP_PATH.ROLE.DETAILS, {
                id: r.id,
              }),
            )
          }>
          <Text truncate>{r.name}</Text>
        </Link>
      ))}
    </Stack>
  );
};
